import { sanitizePlainText } from "./ContentSanitizer";

export class SecureFileStorage {
  private static readonly UPLOAD_BASE_PATH = "/secure-uploads";

  static getSecureUploadPath(userId: string, fileType: string): string {
    const sanitizedUserId = this.sanitizePathComponent(userId);
    const sanitizedFileType = this.sanitizePathComponent(fileType);
    return `${this.UPLOAD_BASE_PATH}/${sanitizedUserId}/${sanitizedFileType}`;
  }

  static getPublicFileUrl(fileId: string): string {
    const sanitizedFileId = this.sanitizePathComponent(fileId);
    return `/api/files/${sanitizedFileId}`;
  }

  static isSecurePath(path: string): boolean {
    if (path.includes("..") || path.includes("./") || path.includes("~"))
      return false;
    if (path.startsWith("/") || path.includes(":\\")) return false;
    if (path.includes("\0") || path.includes("%00")) return false;
    return true;
  }

  private static sanitizePathComponent(component: string): string {
    const sanitized = sanitizePlainText(component) ?? component;
    return sanitized.replace(/[^a-zA-Z0-9_-]/g, "") || "default";
  }
}
